export enum EMobileMenuStyles {
    UNDEFINED = '',
    SLIDE_LEFT = 'slide-left',
    SLIDE_RIGHT = 'slide-right',
    DROPDOWN = 'dropdown',
}
